import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { EVAAIAgentModule } from '../../../libraries/e3duiplatform-eva-mfe/libs/eva/src/lib/ai-agent/ai-agent.module';
import { AIAgentModule } from '../ai-agent/ai-agent.module';
import { DividerModule } from '../divider/divider.module';
import { MenuModule } from './../../menu/menu.module';
import { NotificationModule } from './../../notification/notification.module';
import { SharedMainModule } from './../../shared-main/shared-main.module';
import { UserProfileDetailsModule } from './../user-profile-details/user-profile-details.module';
import { AppHeaderComponent } from "./app-header.component";

@NgModule({
    imports: [
        NgbModule,
        CommonModule,
        FormsModule,
        TranslateModule.forChild({
            loader: provideTranslateHttpLoader({ prefix: "./assets/i18n/", suffix: '.json?v=' + Date.now() }),
        }),
        ReactiveFormsModule,
        SharedMainModule,
        MenuModule,
        NotificationModule,
        DividerModule,
        UserProfileDetailsModule,
        AIAgentModule,
        EVAAIAgentModule
    ],
    declarations: [
        AppHeaderComponent
    ],
    exports: [
        AppHeaderComponent,
        NgbModule,
        FormsModule,
        CommonModule,
    ],
    providers: []
})

export class AppHeaderModule {
}
